module.exports = __webpack_public_path__ + "img/3.2cfffe5d.png";